import Vue from 'vue'
import { Button, Menu, MenuItem, Input, Submenu, Carousel, CarouselItem, Drawer, Tooltip, Popover, Badge, Table, TableColumn, Card, Row, Col, InputNumber } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(Button)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(InputNumber)
